// extracted by mini-css-extract-plugin
module.exports = {"Emoji":"_21ReU4-kmWdEheg0AggGsf","icon":"_27k7MQv2nYuxj8lwkW9fEu"};